/* eslint-disable @typescript-eslint/no-explicit-any */
import { createSlice } from "@reduxjs/toolkit";
import { clearSession, getFromLocalStorage, removeFromLocalStorage, saveInLocalStorage } from "../../utils/Util";

export const initialState = {
  status: '',
  user: {}
};

export const loginSlice = createSlice({
  name: "login",
  initialState,
  reducers: {
    setAuthenticated: (state, action) => {
      state.status = action.payload.status;
      state.user = action.payload.user;
      saveInLocalStorage(
        'auth_data',
        JSON.stringify(action.payload.user)
      );
    },
    setLocalLogout: (state) => {
      state.status = '';
      localStorage.clear();
    },
    checkAuthenticated: (state) => {
      const data = getFromLocalStorage('auth_data');
      
      if (data) {
        const sessionData = JSON.parse(data);
        if (sessionData) {
          state.status = 'authenticated';
          state.user = sessionData;
        }
      }
    },
  },
});
export const loginSelector = (state) => state.login;
export const { setAuthenticated, setLocalLogout, checkAuthenticated } =
  loginSlice.actions;
export default loginSlice.reducer;
